export const selectAllIngredients = (reduxState) => {
  return reduxState.ingredients.allIngredients;
};
